import { Injectable } from '@angular/core';
import { HelperService } from '../../services/utils/helper.service';
import { ApiService } from '../../services/api/api.service';
import { OPERATION, COMPONENTS, CONSTANTS, PHONE_TYPE, TABLE_CELL_WIDTH, SORT_TYPE, TABLE_SORT_ORDER } from '../../dataModels/constants';
import { CONFIG } from '../../dataModels/config';
import { CompAccessService } from '../../services/compAccess/comp-access.service';
import { FacilityService } from '../facility/facility.service';
import { LoadingService } from '../shared/app-loading/loading.service';
import { lastValueFrom } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { ListEntityComponent } from './entity/list-entity/list-entity.component';
/**
 * Vendor Service
 */
@Injectable({
  providedIn: 'root',
})
export class VendorService {
  /**
   * Constructor to inject dependency
   * @param helperService instance of helperService
   * @param apiService instance of apiService
   * @param compAccessService instance of compAccessService
   * @param facilityService instance of facilityService
   * @param loadingService instance of loadingService
   */
  constructor(
    private helperService: HelperService,
    private apiService: ApiService,
    private compAccessService: CompAccessService,
    private facilityService: FacilityService,
    private loadingService: LoadingService,
    private userService: UserService
  ) { }

  /**
   * headers for vendors
   */
  getVendorHeaders() {
    return [
      {
        text: 'Vendor Name',
        field: 'vendorName',
        cellTemplate: 'LINK',
      },
      {
        text: 'Status',
        field: 'vendorStatus',
      },
    ];
  }

  /**
   * get list of vendors
   */
  async getVendorList(activeFlag: boolean) {
    let request = {
      objects: [
        {
          name: OPERATION.INTERFACE.SEARCH_VENDOR

        },
      ]
    } as any;
    if (activeFlag) {
      request = {
        objects: [
          {
            name: OPERATION.INTERFACE.SEARCH_VENDOR, 
            // params: {
            //   vendorStatus: "ACTIVE"
            // }

          },
        ]
      };
    }

    let vendorList = [];

    //INTFC_ADMIN_BUNDLE
    //  const url = this.helperService.isUserLoggedIn ? CONFIG.GET_MS_INTERFACE_BUNDLE : CONFIG.GET_HOME_SEARCH_VENDOR;
    const url = CONFIG.GET_HOME_SEARCH_VENDOR;
    const result = await lastValueFrom(this.apiService.msPost(url, request));
    // if (this.helperService.isUserLoggedIn) {
    //   if (this.helperService.isValidGetResult(result) && result.objects[0].json) {
    //     vendorList = result.objects[0].json;
    //   }
    // } else {
    //   if (result.json) {
    //     vendorList = result.json;
    //   }
    // }

    if (result.json) {
      vendorList = result.json;
    }


    return vendorList;
  }

  /**
   * check if user has add system access
   */
  async checkAddCompAccess() {
    return await this.compAccessService.checkAccess([COMPONENTS.VENDOR.ADD_VENDOR]);
  }

  /**
   * check if user has update system access
   */
  async checkUpdateCompAccess() {
    return await this.compAccessService.checkAccess([COMPONENTS.VENDOR.UPDATE_VENDOR]);
  }

  /**
   * Create Vendor
   * @param generalInfo Systems general accordion form values
   * @param contactInfo Systems contact accordion list
   * @param comment Systems comment accordion form values
   */
  async createVendor(generalInfo, contactInfo, comment) {
    this.loadingService.displayLoader(`Creating Vendor ${generalInfo.vendorName.toUpperCase()}`);
    const request = {
      action: 'CREATE_VENDOR',
      vendorName: generalInfo.vendorName,
      vendorSoftware: generalInfo.vendorSoftware,
      vendorStatus: generalInfo.status,
      contactList: this.facilityService.formContactListRequest(contactInfo, CONSTANTS.ADD),
      comment,
    };

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.MS_MANAGE_VENDOR, request));

    this.loadingService.hideLoader();

    
    return result;
  }


  async getVendorNote(vendorId) {
    const request = {
      objects: [
        {
          name: OPERATION.GLOBAL.GET_NOTE,
          params: {
            idSeq : vendorId,
          },
        },
      ],
    };

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.GET_GLOBAL_BUNDLE, request));

    const vendorNote = {
      isError: false,
      notesList: [],
    };

    if (this.helperService.isValidGetResult(result)) {
      vendorNote.notesList = this.parseNotes(result.objects[0].json);
    } else {
      vendorNote.isError = true;
    }

    return vendorNote;
  }


  /**
   * get details of the vendor
   * @param vendorIdSeq vendorIdSeq
   */
  async getVendorDetails(vendorIdSeq) {
    //  this.loadingService.displayLoader('Getting details of the Vendor');
    const request = {
      objects: [
        {
          name: OPERATION.FACILITY.GET_VENDOR,
          params: {
            vendorIdSeq,
          },
        },
      ],
    };

    const vendorData = {
      generalInfo: {
        vendorName: '',
        vendorSoftwareName: '',
        status: '',
      },
      contact: [],
      notesList: [],
    };

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.GET_INTFC_BUNDLE, request));
    if (this.helperService.isValidGetResult(result) && result.objects[0].json) {
      if (result.objects[0].json && result.objects[0].json && result.objects[0].json.length > 0) {
        const vendorInfo = result.objects[0].json[0];
        vendorData.generalInfo.vendorName = vendorInfo.vendorName;
        vendorData.generalInfo.vendorSoftwareName = vendorInfo.vendorSoftware;
        vendorData.generalInfo.status = vendorInfo.vendorStatus;
        const loggedInUser = this.userService.getUser();
        console.log("service");
        vendorData.contact = [];
        // this.facilityService.getContact(loggedInUser.defaultFacilityId, loggedInUser.idSeq).then((response) => {
        //   if (response.hasData) {
        //     console.log(this.facilityService.parseContact(response.contactList))
        //     vendorData.contact = this.facilityService.parseContact(response.contactList);
        //   }
        // });

        // vendorData.notesList = this.parseNotes(result.objects[0].json.note.json);
      }
    }
    // this.loadingService.hideLoader();
    return vendorData;
  }

  /**
   * parse noteList and decode comments
   */
  parseNotes(notesList) {
    if (notesList instanceof Array) {
      for (const note of notesList) {
        note.comments = this.helperService.decodeJsonString(note.comments);
      }
    } else {
      notesList = [];
    }
    return notesList;
  }

  /**
   * get headers for System
   */
  getNoteHeaders() {
    return [
      {
        text: 'User',
        field: 'userCreated',
        cssClass: TABLE_CELL_WIDTH.SMALL,
      },
      {
        text: 'Date Created',
        field: 'dateCreated',
        cssClass: TABLE_CELL_WIDTH.SMALL,
        sortType: SORT_TYPE.DATE,
        sort: true,
        sortOrder: TABLE_SORT_ORDER.DESC,
      },
      {
        text: 'Comments',
        field: 'comments',
        cssClass: TABLE_CELL_WIDTH.MEDIUM,
      },
    ];
  }

  /**
   * Update Vendor
   * @param origVendorInfo vendor information
   * @param generalInfo Systems general accordion form values
   * @param contactInfo Systems contact accordion list
   * @param comment Systems comment accordion form values
   */
  async updateVendor(origVendorInfo, generalInfo, contactInfo, comment) {
    this.loadingService.displayLoader(`Updating Vendor ${generalInfo.vendorName.toUpperCase()}`);
    const request = {
      action: 'UPDATE_VENDOR',
      vendorName: generalInfo.vendorName,
      vendorSoftware: generalInfo.vendorSoftware,
      vendorStatus: generalInfo.status,
      contactList: this.facilityService.formContactListRequest(contactInfo, CONSTANTS.UPDATE),
      comment,
      vendorIdSeq: origVendorInfo.vendorIdSeq,
    };

    const result = await lastValueFrom(this.apiService.msPost(CONFIG.MS_MANAGE_VENDOR, request));

    this.loadingService.hideLoader();

    return result;
  }

  /**
   * check access
   */
  async checkAccess() {
    return this.compAccessService.checkAccess([COMPONENTS.VENDOR.ADD_VENDOR, COMPONENTS.VENDOR.VIEW_VENDOR]);
  }
}
